import React from "react";
import { Box, Backdrop, CircularProgress } from "@mui/material";
interface LoadinWrapProps {
  active: boolean;
  children: any;
  spinnerSize?: number;
  keepScreenVisible?: boolean;
  lightBackdrop?: boolean;
}
const LoadingWrap: React.FC<LoadinWrapProps> = ({
  active,
  children,
  spinnerSize = 40,
  keepScreenVisible = false,
  lightBackdrop = false,
}): React.JSX.Element => {
  const useInvisible = keepScreenVisible;
  const useLight = lightBackdrop && !useInvisible;
  return (
    <Box>
      {children}
      <Backdrop
        invisible={useInvisible}
        sx={{
          backgroundColor: useLight ? "rgba(255,255,255,0.9)" : undefined,
          backdropFilter: useLight ? "blur(2px)" : undefined,
          color: useInvisible || useLight ? undefined : "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={active}
        // onClick={handleClose}
      >
        <CircularProgress
          color={useInvisible || useLight ? "primary" : "inherit"}
          size={spinnerSize}
        />
      </Backdrop>
    </Box>
  );
};
export default LoadingWrap;
